import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon, FontAwesomeIconProps } from 'atoms/icons';
import { FullWidthContainer } from 'atoms/layout/FullWidthContainer';
import { Vertical } from 'atoms/layout/flex';
import { HeadlineS, LabelS } from 'atoms/typography';
import { Row } from 'components/seo/ui';

import { Transfer, Props as TransferProps } from './Transfer';

const StyledLabelS = styled(LabelS)`
  text-transform: uppercase;
`;

type Props<T extends string> = {
  displayName: string;
  stats: TransferProps<T>['stats'];
  icons: Record<T, FontAwesomeIconProps['icon']>;
  transfers: TransferProps<T>['transfer'][];
};

export const Transfers = <T extends string>({
  displayName,
  stats,
  icons,
  transfers,
}: Props<T>) => {
  return (
    <FullWidthContainer>
      <Vertical gap={1.5}>
        <HeadlineS as="h2">
          <FormattedMessage
            id="Seo.Transfers.playerTransferHistory"
            defaultMessage="{player} transfer history"
            values={{ player: displayName }}
          />
        </HeadlineS>
        <Vertical>
          <Row
            style={{
              gridTemplateColumns: `var(--triple-unit) 1fr repeat(${stats.length}, calc(4 * var(--unit)))`,
            }}
          >
            <StyledLabelS as="p" color="var(--c-nd-600)" bold>
              <FormattedMessage id="Seo.Transfers.club" defaultMessage="Club" />
            </StyledLabelS>
            <span />
            {stats.map(stat => (
              <LabelS as="p" key={stat} color="var(--c-nd-600)">
                <FontAwesomeIcon icon={icons[stat]} />
              </LabelS>
            ))}
          </Row>
          {transfers
            .sort((a, b) => b.startDate.getTime() - a.startDate.getTime())
            .map(transfer => (
              <Transfer key={transfer.id} transfer={transfer} stats={stats} />
            ))}
        </Vertical>
      </Vertical>
    </FullWidthContainer>
  );
};
